import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpIcon, MicIcon, SparklesIcon } from 'lucide-react';
import { atnaChips } from '../../data/loisirs';
import { InscriptionDialog } from './InscriptionDialog';
interface LoisirsAtnaProps {
  onChip: (chip: string) => void;
}
const PANEL_LAYOUT_ID = 'atna-recreation-panel';
export function LoisirsAtna({
  onChip
}: LoisirsAtnaProps) {
  const [value, setValue] = useState('');
  const [openedWith, setOpenedWith] = useState<string | null>(null);
  const open = (text: string) => {
    const trimmed = text.trim();
    if (!trimmed) return;
    setOpenedWith(trimmed);
    setValue('');
  };
  return <section aria-labelledby="atna-recreation-title" data-id="element-1489" data-mp="546daoifn5cx">
      <h2 id="atna-recreation-title" className="sr-only" data-id="element-1490" data-mp="52licxs7hkej">
        Search assisted by ATNA
      </h2>

      {openedWith !== null ? <div className="h-[66px]" aria-hidden="true" data-id="element-1491" data-mp="srxsq0z9ryif" /> : <motion.div layoutId={PANEL_LAYOUT_ID} style={{
      borderRadius: 999
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-1492" data-mp="xm1wych5hsft">
          <form onSubmit={event => {
        event.preventDefault();
        open(value);
      }} className="flex items-center gap-3 rounded-full border border-slate-200 bg-white py-2.5 pl-5 pr-2.5 shadow-lg shadow-ville-navy/5 transition-colors duration-150 ease-ville focus-within:border-ville-indigo" data-id="element-1493" data-mp="1piglgy3y81hh">
            <SparklesIcon className="h-5 w-5 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-1494" data-mp="287wwwgh69eco" />
            <label htmlFor="atna-recreation" className="sr-only" data-id="element-1495" data-mp="28a9gey2kvwru">
              What are you looking for?
            </label>
            <input id="atna-recreation" type="text" value={value} onChange={event => setValue(event.target.value)} placeholder="Register my child, find an activity…" className="min-w-0 flex-1 border-0 bg-transparent py-2.5 text-base text-ville-navy placeholder:text-slate-400 focus:outline-none sm:text-lg" data-id="element-1496" data-mp="2i5jiflsz845m" />
            <button type="button" aria-label="Dictate your search" className="grid h-10 w-10 shrink-0 place-items-center rounded-full text-slate-500 transition-colors duration-150 ease-ville hover:bg-slate-100 hover:text-ville-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1497" data-mp="1hh0u1dh4dgbg">
              <MicIcon className="h-5 w-5" aria-hidden="true" data-id="element-1498" data-mp="1wd8l8xqy3i08" />
            </button>
            <button type="submit" aria-label="Send the search" className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-ville-lime text-ville-navy transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1499" data-mp="20ek5enr1vb11">
              <ArrowUpIcon className="h-5 w-5" aria-hidden="true" data-id="element-1500" data-mp="2k55q24vz99ru" />
            </button>
          </form>
        </motion.div>}

      <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-3" data-id="element-1501" data-mp="3i7d0fkj77a8">
        <p className="text-xs font-semibold uppercase tracking-wider text-ville-indigo" data-id="element-1502" data-mp="3gwask6qi7l8">Powered by ATNA</p>
        <ul className="-mx-5 flex snap-x gap-2.5 overflow-x-auto px-5 sm:mx-0 sm:flex-wrap sm:overflow-visible sm:px-0" data-id="element-1503" data-mp="3uql9jb9gqtdo">
          <li className="shrink-0 snap-start" data-id="element-1504" data-mp="r7s79um4xqyt">
            <button type="button" onClick={() => open('Register my child')} className="rounded-full border border-ville-navy bg-ville-navy px-4 py-2 text-sm font-semibold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1505" data-mp="r6gx9d23jmz9">
              Register my child
            </button>
          </li>
          {atnaChips.map(chip => <li key={chip} className="shrink-0 snap-start" data-id="element-1506" data-mp="1568fjpznbpj2">
              <button type="button" onClick={() => {
            if (chip === 'Find an activity') {
              open(chip);
              return;
            }
            setValue(chip);
            onChip(chip);
          }} className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1507" data-mp="ppa4stcsn6f8">
                {chip}
              </button>
            </li>)}
        </ul>
      </div>

      <AnimatePresence data-id="element-1508" data-mp="13nqbikanowxd">
        {openedWith !== null && <InscriptionDialog key="atna-recreation-inscription" initialText={openedWith} layoutId={PANEL_LAYOUT_ID} onClose={() => setOpenedWith(null)} data-id="element-1509" data-mp="1redm5dbyi0nm" />}
      </AnimatePresence>
    </section>;
}